import React from 'react'
import Historydata from './Table/Historydata'
export default function ProductionHistory() {
  return (
    <div>
    <div>
    <h2 className="font-Montserrat text-xl font-bold text-black">
      Production History
    </h2>
    <div className="border-b-2 border-blue-200 w-20"></div>
  </div>
  <div className="flex flex-wrap justify-center">
  <div
    className="tabelcontainer flex-auto -mt-8 overflow-auto mx-4"
    // "w-[calc(100vw_-_12rem)]"
  >
    <Historydata />
  </div>
</div>
    </div>
  )
}
